"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importStar(require("react"));
var styled_system_1 = require("styled-system");
var styled_components_1 = __importStar(require("styled-components"));
var Box_1 = __importDefault(require("./Box"));
var Icon_1 = __importDefault(require("./Icon"));
var Tooltip_1 = __importDefault(require("./Tooltip"));
var StyledTooltip = styled_components_1["default"](Tooltip_1["default"])(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 300px;\n\n  ", " {\n    width: ", "px;\n  }\n"], ["\n  width: 300px;\n\n  ", " {\n    width: ", "px;\n  }\n"])), styled_system_1.themeGet('mediaQueries.md'), function (_a) {
    var width = _a.width;
    return width;
});
var StyledIconTooltip = styled_components_1["default"](Box_1["default"])(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  cursor: pointer;\n  display: inline-block;\n\n  ", " {\n    display: none;\n    position: absolute;\n    top: 20px;\n    margin-left: -5px;\n\n    ", "\n  }\n\n  &:hover ", " {\n    display: block;\n  }\n"], ["\n  cursor: pointer;\n  display: inline-block;\n\n  ", " {\n    display: none;\n    position: absolute;\n    top: 20px;\n    margin-left: -5px;\n\n    ",
    "\n  }\n\n  &:hover ", " {\n    display: block;\n  }\n"])), StyledTooltip, function (_a) {
    var active = _a.active;
    return active && styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        display: block;\n      "], ["\n        display: block;\n      "])));
}, StyledTooltip);
var TransparentButton = styled_components_1["default"].button(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  color: ", ";\n  background-color: ", ";\n  border: none;\n  cursor: pointer;\n  height: ", "px;\n  width: ", "px;\n  padding: 0;\n  margin: auto;\n"], ["\n  color: ", ";\n  background-color: ", ";\n  border: none;\n  cursor: pointer;\n  height: ", "px;\n  width: ", "px;\n  padding: 0;\n  margin: auto;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.transparent;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.transparent;
}, function (_a) {
    var size = _a.size;
    return size || 24;
}, function (_a) {
    var size = _a.size;
    return size || 24;
});
var ClickableIcon = styled_components_1["default"](Icon_1["default"])(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  pointer-events: none;\n"], ["\n  pointer-events: none;\n"])));
var IconTooltip = function (_a) {
    var children = _a.children, width = _a.width, size = _a.size, position = _a.position, ariaLabel = _a.ariaLabel, _b = _a.icon, icon = _b === void 0 ? 'information' : _b, rest = __rest(_a, ["children", "width", "size", "position", "ariaLabel", "icon"]);
    var _c = react_1.useState(false), active = _c[0], setActive = _c[1];
    return (react_1["default"].createElement(StyledIconTooltip, __assign({ active: active }, rest),
        react_1["default"].createElement(TransparentButton, { onClick: function () { return setActive(!active); }, size: size, type: "button", "aria-label": ariaLabel },
            react_1["default"].createElement(ClickableIcon, { name: icon, size: size, "data-testid": "tooltipIcon" })),
        react_1["default"].createElement(StyledTooltip, { center: position === 'center', right: position === 'right', left: position === 'left', width: width, zIndex: 100, "data-testid": "tooltipBox" },
            react_1["default"].createElement(Box_1["default"], null, children))));
};
IconTooltip.displayName = 'IconTooltip';
IconTooltip.defaultProps = {
    width: 430,
    size: 14,
    position: 'center'
};
exports["default"] = IconTooltip;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=IconTooltip.js.map